import { Component, EventEmitter, Input, Output, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-stamo-slider',
  templateUrl: './stamo-slider.component.html',
  styleUrls: ['./stamo-slider.component.scss']
})
export class StamoSliderComponent {
  @Input({ required: true }) value!: number;
  @Input() min = 1;
  @Input() max = 100;
  @Input() disabled = false;

  @Output() valueChange = new EventEmitter<number>();
  @Output() onChange = new EventEmitter<number>();
  @Output() onSlideEnd = new EventEmitter<number>();


  visible = true;

  constructor() {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes['max']) {
      this.refreshSlider();
    }
  }

  private refreshSlider() {
    // Re-render the rank slider
    this.visible = false;
    setTimeout(() => this.visible = true, 0);
  }

  handleModelChange(e: any) {
    this.valueChange.emit(e)
  }

  handleOnChange(e: any) {
    this.onChange.emit(e.value!)
  }

  handleOnSlideEnd(e: any) {
    this.onSlideEnd.emit(e.value!)
  }
}
